var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "user-chat-box bg-light card text-sm",
    },
    [
      _c(
        "div",
        {
          staticClass: "card-header bg-dark text-center text-white pa-0",
          on: {
            click: _vm.toggleCollapse,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center pa-2",
            },
            [
              _vm.unread > 0
                ? _c(
                    "span",
                    {
                      staticClass: "badge badge-danger",
                    },
                    [_vm._v(_vm._s(_vm.unread))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "flex-grow-1 mb-0",
                },
                [_vm._v("\n        💬 ติดต่อเอเจนท์\n      ")]
              ),
              _vm._v(" "),
              _c("i", {
                class: {
                  fa: true,
                  "fa-caret-down": true,
                  "d-flex": true,
                  "mr-2": true,
                  more: !_vm.isChatOpen,
                },
                attrs: {
                  id: "caret",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.hotnews.length > 0
            ? _c(
                "marquee",
                {
                  staticClass: "bg-primary text-white",
                  attrs: {
                    id: "marquee",
                    scrollamount: "4",
                  },
                },
                _vm._l(_vm.hotnews, function (text) {
                  return _c("div", {
                    staticClass: "d-inline-block mx-5",
                    domProps: {
                      innerHTML: _vm._s(text),
                    },
                  })
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            collapse: !_vm.isChatOpen,
          },
          attrs: {
            id: "messageWrapper",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-body",
              attrs: {
                id: "messageContainer",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm border-1 w-100",
                  attrs: {
                    disabled: !_vm.is_more,
                  },
                  on: {
                    click: _vm.fetchMore,
                  },
                },
                [_vm._v("\n        โหลดอีก\n      ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.messages, function (message) {
                return _c("user-message", {
                  key: message.id,
                  attrs: {
                    message: message,
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-footer p-0",
            },
            [
              _c("v-textarea", {
                staticStyle: {
                  background: "#fefefe",
                },
                attrs: {
                  "auto-grow": "",
                  filled: "",
                  "full-width": "",
                  "hide-details": "",
                  placeholder: "ข้อความ...",
                  rows: "1",
                  type: "text",
                },
                on: {
                  keyup: function ($event) {
                    if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                      return null
                    return _vm.sendMessage.apply(null, arguments)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "my-3",
                            on: {
                              click: _vm.sendMessage,
                            },
                          },
                          [_vm._v("\n            mdi-send\n          ")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.typed_message,
                  callback: function ($$v) {
                    _vm.typed_message = $$v
                  },
                  expression: "typed_message",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.is_loading
            ? _c(
                "div",
                {
                  attrs: {
                    id: "messageLoading",
                  },
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      indeterminate: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }